import { FaKey, FaCheck, FaMailBulk, FaEnvelope } from "react-icons/fa"
import { IoEye, IoEyeOff } from "react-icons/io5"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { useState } from "react"
import { AlertType, RetAPI, TypePasswordProps } from "../../Utils/Types"
import { RememberPassword } from "./LoginService"

export const UserRememberPassword = () => {

    const [visible, setVisible] = useState(false)
    const [messageType, setMessageType] = useState<AlertType>("DANGER")
    const [message, setMessage] = useState("")
    const [email, setEmail] = useState("")
    const [loading, setLoading] = useState(false)
    const [emailEnviado, setEmailEnviado] = useState(false)    

    const handleCloseMessage = () => {
        setVisible(false)
    }

    const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    }

    const handleSendMail = async () => {

        setVisible(false)
        setLoading(true)
        const retorno: RetAPI = await RememberPassword(email)
        
        setLoading(false)

        if (retorno.error){
            setMessage(retorno.msg || "")
            setVisible(true)
            setMessageType("DANGER")
            return
        }

        setEmailEnviado(true)
    }

    return <div className="flex items-center justify-center h-full w-full bg-white outline-none">
                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage}/>
                    <div className="w-full md:max-w-[500px] h-auto border border-gray-200 rounded-md shadow-md shadow-gray-300">
    
                        <div className="flex w-full h-20 items-center justify-around bg-indigo-900">
                            <img src="https://www.tiautomacao.com.br/imagens/logo.png" width="200" />
                            
                        </div>
                        
                        <div className="w-full h-auto flex items-center justify-center py-5">
                            <FaKey className="w-5 h-5 text-blue-500"/><span className="text-lg text-blue-500 ml-2 font-bold">Redefinir senha</span>
                        </div>
    
                        <div className="w-full px-5 mb-5">
    
                            <div className={`flex justify-end items-center w-full h-auto relative`}>
                                <input disabled={emailEnviado} type="email" className="w-full py-5 px-2 border text-blue-300 font-bold border-gray-300 text-lg rounded-md mt-2 outline-none" placeholder="Digite seu E-mail" 
                                value={email} onChange={handleChangeEmail}/>                                    
                            </div>
                                
                            { !emailEnviado && 
                                <button disabled={loading} className="flex items-center justify-center text-white w-full py-5 bg-green-500 duration-150 hover:bg-green-600 mt-4
                                                    shadow-md shadow-green-700 disabled:opacity-50" onClick={handleSendMail}>
                                    <FaEnvelope /> <span className="font-bold mx-1">Enviar E-mail</span>
                                </button>
                            }
                            
                            { emailEnviado && 
                                <>
                                    <div className="w-full px-5 py-5 rounded-sm mb-5 mt-5 text-base bg-green-500">
                                        <span className="text-white font-bold">Acesse sua conta de e-mail e clique no link enviado para redefinir a sua senha</span>
                                    </div>

                                    <div className="flex justify-center w-full px-5 py-5 rounded-sm mb-5 mt-5 text-base ">
                                        <a href="/login" className="text-blue-500 font-bold hover:text-blue-600">Clique aqui para acessar o login</a>
                                    </div>
                                </>

                            }
                            

                        </div>
                        
                        
                    </div>
               </div>
}